const port = new URL('../../icons/port.png', import.meta.url).href

export default {
  type: 'Port',
  description: 'port shape',
  icon: port,
  group: ['BCS', 'CCS', 'EQP', 'SCS'],
  model: {
    type: 'Port',
    left: 100,
    top: 100,
    width: 20,
    height: 20
  }
}
